export default {
    loggedIn: false,
    inEventPreview: false,
    inEventDetail: false,
    user: {},
    organizations: [],
    dataCompany: {}
}